<template>
	<v-container grid-list-xl>		
		<v-form v-model="isAddValid">
			<v-layout row wrap>
              <v-tabs slider-color="grey">
                <v-tab class="tab" :key="1" ripple>Details</v-tab>
                <v-tab class="tab" :key="2" ripple>Packages</v-tab>
                <v-tab class="tab" :key="3" ripple>Minimum Cost</v-tab>
                <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
                  <v-container grid-list-xl>
                    <v-layout row wrap>
                      <v-flex lg6>
                        <label class="blackLabel">* Name:</label>
                        <v-text-field label="Vehicle Name" :rules="nameRules" solo v-model="vehicleName" single-line required></v-text-field>
                      </v-flex>
                      <v-flex lg6>
                        <label class="blackLabel">* Registration No:</label>
                        <v-text-field label="Vehicle Registration No." :rules="regRules" solo v-model="vehicleRegistration" single-line required></v-text-field>
                      </v-flex>
                      <v-flex lg12>
                        <label class="blackLabel">* Description:</label>
                        <v-text-field label="Vehicle Description" :rules="descriptionRules" solo v-model="vehicleDescription" single-line required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
                  <v-container grid-list-xl>
                    <v-layout row wrap>
                      <div style="float: right">
                        <v-btn style="float: right;" color="success" class="text-xs-right" @click.stop="fncAddVehiclePackage()">Add Package</v-btn>
                      </div>
                      <br /><br />
                      <v-data-table :headers="packageHeaders" :items="objVehicleAddSelectedPackages" class="elevation-1" hide-actions disable-initial-sort>
                        <template slot="items" slot-scope="props">
                          <td width="65%" class="text-xs-right"><v-select :items="objVehicleEditPackages" label="Package" v-model="props.item.package" autocomplete solo item-value="id"></v-select></td>
                          <td width="25%" class="text-xs-right"><v-text-field :rules="nameRules" solo v-model="props.item.quantity" single-line required></v-text-field></td>
                          <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteVehiclePackage(props.item.package)"><i class="material-icons">delete_forever</i></a></td>
                        </template>
                      </v-data-table>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
                  <v-container grid-list-xl>
                    <v-layout row wrap>
                      <div style="float: right">
                        <v-btn style="float: right;" color="success" class="text-xs-right" @click.stop="fncAddvehicleMatrix()">Add Minimum Cost</v-btn>
                      </div>
                      <br /><br />
                      <v-data-table :headers="matrixHeaders" :items="objVehicleAddMatrix" class="elevation-1" hide-actions disable-initial-sort>
                        <template slot="items" slot-scope="props">
                          <td width="45%" class="text-xs-right"><v-text-field solo v-model="props.item.distance" single-line required></v-text-field></td>
                          <td width="45%" class="text-xs-right"><v-text-field solo v-model="props.item.cost" single-line required></v-text-field></td>
                          <td width="10%" class="text-xs-right"><a @click.prevent="fncDeleteVehicleMatrix(props.item.distance)"><i class="material-icons">delete_forever</i></a></td>
                        </template>
                      </v-data-table>
                    </v-layout>
                  </v-container>
                </v-tab-item>    
                </v-tabs>
                <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
                  <div style="float: right">
                    <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
                    <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
                    <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddPackage()">Save</v-btn>
                    <small>* The button will activate once all required fields have been completed</small>
                  </div>
                </div>                
</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";
	
	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
				runAdd: false,
				isAddValid: false,
                vehicleName: '',
                vehicleRegistration: '',
                vehicleDescription: '',
                packageHeaders: [
                  { text: 'Package', value: 'package', width: '65%' },
                  { text: 'Quantity', value: 'qty', width: '25%' },
                  { text: 'Delete', value: 'delete', width: '10%' },
                ],
                matrixHeaders: [
                  { text: 'Distance (km)', value: 'distance', width: '45%' },
                  { text: 'Price (R)', value: 'price', width: '45%' },
                  { text: 'Delete', value: 'delete', width: '10%' },
                ],
				nameRules: [
					v => !!v || 'Vehicle name is required',				
				],
				descriptionRules: [
					v => !!v || 'Vehicle description is required',				
				],
                regRules: [
					v => !!v || 'Vehicle short name is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncAddPackage() {
				this.runAdd = true;	
				this.$store.dispatch({
                  type: 'fncAddVehicle',
                  name: this.vehicleName,                  
                  registration: this.vehicleRegistration,
                  description: this.vehicleDescription
                });
                this.runAdd = false;	
            },
            fncAddvehicleMatrix() {
              this.$store.commit('fncAddvehicleMatrixNew');
            },
            fncDeleteVehicleMatrix(matrixId) {
              this.$store.commit({
                type: 'fncDeleteVehicleMatrixNew',
                id: matrixId
              })
            },
            fncAddVehiclePackage() {
              this.$store.commit('fncAddVehiclePackageNew')
            },
            fncDeleteVehiclePackage(packId) {
              this.$store.commit({
                type: 'fncDeleteVehiclePackageNew',
                id: packId
              })
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
                'globalModalParams',
                'objVehicleAddMatrix',
                'objVehicleAddSelectedPackages',
                'objVehicleEditPackages'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>